module.exports = __webpack_public_path__ + "img/ИФ-1(А)-032-m.82d5884f.png";